import _ from 'underscore';
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ReactTemplate } from '@bingads-webui-react/react-template';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { notificationApi } from '@bingads-webui-react/notification-center';
import { PermissionsContext } from '@bingads-webui-react/hoc-with-permissions';
import { getWordpressInstructionsStyles } from '../styles/wordpress-instructions-styles';
import { CopyTag } from './copy-tag';

import imageStep2 from '../../media/squarespace-step2.png';
import imageStep3a from '../../media/squarespace-step3a.png';
import imageStep3b from '../../media/squarespace-step3b.png';
import { generateTag } from '../utils/tag-generator';

const SquareSpaceInstructionsUnstyled = (props) => {
  const { classes, tag, logTrace } = props;
  const i18n = useContext(I18nContext);
  const permissions = useContext(PermissionsContext);
  const isUetSpaTrackingEnabled = _.result(permissions.dynamic, 'UetAutoSpaTracking');

  const noTranslateModel = { noTranslate: text => (<b>{text}</b>) };
  const step3Bulletin1Template = i18n.getString(_TL_('1. Select {{noTranslate}}Settings{{/noTranslate}}.'));
  const step3Bulletin2Template = i18n.getString(_TL_('2. Select {{noTranslate}}Advanced{{/noTranslate}}.'));
  const step3Bulletin3Template = i18n.getString(_TL_('3. Select {{noTranslate}}Code injection{{/noTranslate}}.'));
  const step3Bulletin4Template = i18n.getString(_TL_('4. Paste UET code in the {{noTranslate}}HEADER{{/noTranslate}} section.'));
  const step3Bulletin5Template = i18n.getString(_TL_('5. Click {{noTranslate}}Save{{/noTranslate}}.'));

  const onCopyCallback = ({ error, message, tagContent }) => {
    if (error) {
      logTrace(`[SquareSpace] Copy error. Error: ${error} tagContent: ${JSON.stringify(tagContent)}`);
      notificationApi.showWarning(message);
    } else {
      logTrace('[SquareSpace] Copy success.');
      notificationApi.showInfo(message);
    }
  };

  const tagContainerStyle = {
    container: {
      fontSize: '14px',
      lineHeight: '20px',
      color: '#323130',
      marginBottom: '12px',
      border: '1px solid black',
      padding: 20,
      wordWrap: 'break-word',
      whiteSpace: 'pre-wrap',
      width: 500,
    },
  };

  const containerStyle = _.extend({}, tagContainerStyle.container);
  return (
    <div className={classNames(classes.container, 'insert-instruction')}>
      <div className={classNames(classes.instructionContainer)}>
        <div className={classNames(classes.instructionTitle)}>
          <p>{i18n.getString(_TL_('Step 1: Copy the UET tag below.'))}</p>
        </div>
        <div className={classNames(classes.instructionBody)}>
          <CopyTag
            tag={tag}
            onCopyCallback={onCopyCallback}
            platformName="sqsp_ui"
          />
          <div style={containerStyle}>
            {generateTag(tag.type, tag.id, false, 'sqsp_ui', isUetSpaTrackingEnabled)}
          </div>
        </div>
      </div>
      <div className={classNames(classes.instructionContainer)}>
        <div className={classNames(classes.instructionTitle)}>
          <p>{i18n.getString(_TL_('Step 2: Login to your SquareSpace account. Select the webpage you would like to track conversions.'))}</p>
        </div>
        <div className={classNames(classes.instructionBody)}>
          <div>
            <img className={classNames(classes.instructionImage)} src={imageStep2} alt={i18n.getString(_TL_('SquareSpace theme admin page'))} />
          </div>
        </div>
      </div>
      <div className={classNames(classes.instructionContainer)}>
        <div className={classNames(classes.instructionTitle)}>
          <p>{i18n.getString(_TL_('Step 3: Install the tag.'))}</p>
        </div>
        <div className={classNames(classes.instructionBody)}>
          <div>
            <img className={classNames(classes.instructionImage)} src={imageStep3a} alt={i18n.getString(_TL_('install tag selector'))} />
          </div>
          <div>
            <img className={classNames(classes.instructionImage)} src={imageStep3b} alt={i18n.getString(_TL_('install tag instruction'))} />
          </div>
          <p>
            <ReactTemplate
              model={noTranslateModel}
              template={step3Bulletin1Template}
            />
          </p>
          <p>
            <ReactTemplate
              model={noTranslateModel}
              template={step3Bulletin2Template}
            />
          </p>
          <p>
            <ReactTemplate
              model={noTranslateModel}
              template={step3Bulletin3Template}
            />
          </p>
          <p>
            <ReactTemplate
              model={noTranslateModel}
              template={step3Bulletin4Template}
            />
          </p>
          <p>
            <ReactTemplate
              model={noTranslateModel}
              template={step3Bulletin5Template}
            />
          </p>
        </div>
      </div>
    </div>
  );
};

SquareSpaceInstructionsUnstyled.propTypes = {
  classes: PropTypes.shape(_.mapObject(
    getWordpressInstructionsStyles(),
    _.constant(PropTypes.string.isRequired)
  )).isRequired,
  tag: PropTypes.shape({
    id: PropTypes.number.isRequired,
    type: PropTypes.oneOf(['Container', 'UET']).isRequired,
  }).isRequired,
  logTrace: PropTypes.func.isRequired,
};

export const SquareSpaceInstructions = withDefaultStyles(SquareSpaceInstructionsUnstyled, getWordpressInstructionsStyles);

